import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        display: "flex",
        gap: ".5rem",
        alignItems: "center",
        padding: ".375rem 1.5rem .375rem .5rem",
        backgroundColor: theme.colors.violet[7],
        position: "sticky",
        top: 0,
        zIndex: 1,
    },
    goBackButton: {
        width: "3rem",
        height: "3rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1.25rem",
        lineHeight: "normal",

        svg: {
            width: "1em",
        },
    },
    title: {
        margin: 0,
        padding: 0,
        fontSize: "1.25rem",
        fontWeight: 500,
        lineHeight: "normal",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: "white",
    },
}))
